import { render, staticRenderFns } from "./crutchList.vue?vue&type=template&id=75070790&scoped=true"
import script from "./crutchList.vue?vue&type=script&lang=js"
export * from "./crutchList.vue?vue&type=script&lang=js"
import style0 from "./crutchList.vue?vue&type=style&index=0&id=75070790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75070790",
  null
  
)

export default component.exports